import { getStyle } from 'lib/DOM';

function findScrollParent(node: any): Node | Window {
  let tempNode: Node = node;

  while (tempNode.parentNode) {
    tempNode = tempNode.parentNode;

    if (tempNode === document.body) {
      break;
    }

    const overflowY =
      getStyle(tempNode as HTMLElement, 'overflow-y') ||
      getStyle(tempNode as HTMLElement, 'overflow');

    if (overflowY === 'auto' || overflowY === 'scroll') {
      return tempNode;
    }
  }
  return window;
}

export default findScrollParent;
